import { render, staticRenderFns } from "./FacetDropdown.vue?vue&type=template&id=2a5cda44&scoped=true&"
import script from "./FacetDropdown.vue?vue&type=script&lang=ts&"
export * from "./FacetDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./FacetDropdown.vue?vue&type=style&index=0&id=2a5cda44&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5cda44",
  null
  
)

export default component.exports